<p-dialog header="{{ platform === 'woocommerce' ? ('shopifyAndWoocommerceDailog.connectWoocommerceAccount' | transloco) : ('shopifyAndWoocommerceDailog.connectShopifyAccount' | transloco)}}" [(visible)]="isAddPlatformAccountDailogVisible" [modal]="true"
  (onHide)="onClosePlatformAccountDailog()" [style]="{ width: '430px' }">
  @if (platform === 'woocommerce') {
    <div class="p-fluid p-2">
      <form class="form-horizontal">
        <!-- <div class="form-group mt-2">
        <label for="storeName" class="form-label">Store Name (Optional)</label>
        <input id="storeName" type="text" pInputText placeholder="Enter your store name" class="form-control"
          [(ngModel)]="woocommerceFormData.storeName" name="storeName" required />
        </div> -->
        <div class="form-group mt-2">
          <label for="storeUrl" class="form-label"><span class="text-danger me-1">*</span>{{ 'shopifyAndWoocommerceDailog.storeUrl' | transloco }}</label>
          <input id="storeUrl" type="text" pInputText [placeholder]="'shopifyAndWoocommerceDailog.enterWoocommerceStoreUrl' | transloco" class="form-control"
            [(ngModel)]="woocommerceFormData.storeUrl" name="storeUrl" required />
            <div class="text-muted fst-italic mt-2">{{ 'shopifyAndWoocommerceDailog.woocommerceStoreUrlHelp' | transloco }}</div>
          </div>
          <div class="mt-4">
            <button pButton type="button" (click)="onConnectWooCommerceAccount()" [label]="'shopifyAndWoocommerceDailog.connectWithWoocommerce' | transloco"
            class="p-button-outlined w-100" [disabled]="!woocommerceFormData.storeUrl"></button>
          </div>
        </form>
      </div>
    }
    @if (platform === 'shopify') {
      <div class="p-fluid p-2">
        <form class="form-horizontal">
          <div class="form-group mt-2">
            <label for="storeUrl" class="form-label"><span class="text-danger me-1">*</span>{{ 'shopifyAndWoocommerceDailog.storeUrl' | transloco }}</label>
            <input id="storeUrl" type="url" pInputText [placeholder]="'shopifyAndWoocommerceDailog.enterShopifyStoreUrl' | transloco"
              class="form-control form-control-sm" [(ngModel)]="storeUrl" name="email" required />
              <div class="text-muted fst-italic mt-2">
                {{ 'shopifyAndWoocommerceDailog.shopifyStoreUrlHelp' | transloco }}
              </div>
            </div>
            <div class="mt-4">
              <button pButton type="button" (click)="onConnectShopifyAccount()" [label]="'shopifyAndWoocommerceDailog.connectWithShopify' | transloco"
              class="p-button-outlined w-100" [disabled]="!storeUrl"></button>
            </div>
          </form>
        </div>
      }
    </p-dialog>